import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "25",
      cy: "25",
      r: "19",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m26.113 16.6-.242 11.044h-1.76L23.89 16.6zm-2.838 13.992q0-.749.484-1.232a1.72 1.72 0 0 1 1.232-.484q.748 0 1.232.484.483.484.484 1.232 0 .749-.484 1.232-.485.484-1.232.484-.726 0-1.232-.484-.484-.484-.484-1.232"
    }, null, -1)
  ])))
}
export default { render: render }